var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeakEncryption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#368FEF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1172.969 322.875c.599 0 1.108-.21 1.527-.629.42-.42.629-.928.629-1.527h0v-8.625c0-.6-.21-1.108-.629-1.528-.42-.419-.928-.628-1.527-.628h0-2.157v-3.19c0-.898.315-1.67.944-2.313.629-.644 1.377-.966 2.246-.966.898 0 1.67.314 2.313.943.644.629.966 1.393.966 2.291h0v3.594c0 .3.105.554.315.764.21.21.464.314.763.314h1.438c.3 0 .554-.105.764-.314.21-.21.314-.465.314-.764h0v-3.594c0-1.887-.674-3.496-2.021-4.829-1.348-1.333-2.958-1.999-4.83-1.999-1.871 0-3.481.674-4.829 2.021-1.317 1.348-1.976 2.98-1.976 4.897h0v3.144h-10.063c-.599 0-1.108.21-1.527.63-.42.419-.629.928-.629 1.527h0v8.625c0 .599.21 1.108.629 1.527.42.42.928.629 1.527.629h15.813z",
    transform: "translate(-1154 -298)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeakEncryption);
export default __webpack_public_path__ + "static/media/weak_encryption.b2cb6167a04a650b5ee0196979a730fa.svg";
export { ForwardRef as ReactComponent };